import { useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, Phone, PhoneCall } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Maintenance({ settings }) {
  const s = settings || {};
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await api.post("/orders", { name: name.trim(), phone: phone.trim(), comment: "Перезвоните (форма со страницы технических работ)", type: "callback" });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Не удалось отправить. Позвоните нам, пожалуйста.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F1720] text-white px-4 py-12" data-testid="maintenance-page">
      <div className="text-center max-w-lg w-full">
        <div className="w-20 h-20 rounded-2xl bg-[#E85D2A]/20 text-[#E85D2A] flex items-center justify-center mx-auto mb-6 animate-pulse">
          <Wrench size={40} />
        </div>
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="w-9 h-9 rounded-lg bg-[#E85D2A] flex items-center justify-center font-display font-bold text-sm">ПП</div>
          <span className="font-display font-bold text-lg">{s.company_name || "Пром-Пластик"}</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-display font-bold">{s.maintenance_title || "Идут технические работы"}</h1>
        <p className="text-slate-400 mt-4 leading-relaxed">{s.maintenance_text}</p>
        {s.phone && (
          <a href={`tel:${s.phone_link}`} className="inline-flex items-center gap-2 mt-8 bg-[#E85D2A] hover:bg-[#D04A1B] text-white rounded-full px-7 py-3.5 font-medium transition-colors">
            <Phone size={18} /> {s.phone}
          </a>
        )}

        <div className="mt-10 bg-white/5 border border-white/10 rounded-2xl p-6 text-left">
          {sent ? (
            <div className="text-center py-4" data-testid="callback-success">
              <div className="text-[#E85D2A] font-display font-bold text-lg">Заявка отправлена!</div>
              <p className="text-slate-400 text-sm mt-2">Мы перезвоним вам, как только сайт заработает.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3" data-testid="callback-form">
              <div className="flex items-center gap-2 justify-center mb-1">
                <PhoneCall size={16} className="text-[#E85D2A]" />
                <span className="text-sm font-medium text-slate-200">Оставьте телефон — перезвоним</span>
              </div>
              <input
                value={name} onChange={(e) => setName(e.target.value)} required minLength={2}
                placeholder="Ваше имя"
                className="w-full bg-white/10 border border-white/10 rounded-lg px-4 py-2.5 text-sm placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-[#E85D2A]/60"
                data-testid="callback-name"
              />
              <input
                value={phone} onChange={(e) => setPhone(e.target.value)} required minLength={10}
                placeholder="Телефон" type="tel"
                className="w-full bg-white/10 border border-white/10 rounded-lg px-4 py-2.5 text-sm placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-[#E85D2A]/60"
                data-testid="callback-phone"
              />
              <button
                type="submit" disabled={sending}
                className="w-full bg-[#E85D2A] hover:bg-[#D04A1B] disabled:opacity-60 text-white rounded-lg py-2.5 text-sm font-medium transition-colors"
                data-testid="callback-submit"
              >
                {sending ? "Отправляем..." : "Перезвоните мне"}
              </button>
            </form>
          )}
        </div>

        <div className="mt-8">
          <Link to="/login" className="text-xs text-slate-500 hover:text-slate-300 transition-colors underline underline-offset-4" data-testid="maintenance-login-link">
            Вход для администратора
          </Link>
        </div>
      </div>
    </div>
  );
}
